export default __webpack_public_path__ + "static/media/static-bg.8b131a83.png";